export default __webpack_public_path__ + "static/media/pflastern-3.862bc539.jpeg";